(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/assets/javascripts/prescript.js');

'use strict';

svs.keno = svs.keno || {};
svs.keno.components = svs.keno.components || {};
svs.keno.components.play = svs.keno.components.play || {};
svs.keno.components.play.views = svs.keno.components.play.views || {};

 })(window);